import type { Page } from '@/domain/model/Page';
import type {
  CatalogItem,
  ContentProvider,
  ExternalContent,
  ExternalContentFilter,
  Unidade,
  UpsertContentProviderCommand,
  UpsertExternalContentCommand,
  UpsertUnidadeCommand,
} from '@/domain/model/ConteudoExterno';
import type {
  ContentProviderGateway,
  ExternalContentGateway,
  UnidadeGateway,
} from '@/application/port/out/ConteudoExternoGateways';
import type {
  ArchiveContentProviderUseCase,
  ArchiveExternalContentUseCase,
  ArchiveUnidadeUseCase,
  BrowseProviderCatalogUseCase,
  CreateContentProviderUseCase,
  CreateExternalContentUseCase,
  CreateUnidadeUseCase,
  ListContentProvidersUseCase,
  ListExternalContentsUseCase,
  ListUnidadesUseCase,
  UpdateContentProviderUseCase,
  UpdateExternalContentUseCase,
  UpdateUnidadeUseCase,
} from '@/application/port/in/ConteudoExternoUseCase';

// ── Provedor ───────────────────────────────────────────────
export class ListContentProviders implements ListContentProvidersUseCase {
  constructor(private readonly g: ContentProviderGateway) {}
  execute(): Promise<ContentProvider[]> { return this.g.list(); }
}
export class CreateContentProvider implements CreateContentProviderUseCase {
  constructor(private readonly g: ContentProviderGateway) {}
  execute(cmd: UpsertContentProviderCommand): Promise<ContentProvider> { return this.g.create(cmd); }
}
export class UpdateContentProvider implements UpdateContentProviderUseCase {
  constructor(private readonly g: ContentProviderGateway) {}
  execute(id: string, cmd: UpsertContentProviderCommand): Promise<ContentProvider> { return this.g.update(id, cmd); }
}
export class ArchiveContentProvider implements ArchiveContentProviderUseCase {
  constructor(private readonly g: ContentProviderGateway) {}
  execute(id: string): Promise<void> { return this.g.archive(id); }
}
export class BrowseProviderCatalog implements BrowseProviderCatalogUseCase {
  constructor(private readonly g: ContentProviderGateway) {}
  execute(providerId: string): Promise<CatalogItem[]> { return this.g.browseCatalog(providerId); }
}

// ── Unidade ────────────────────────────────────────────────
export class ListUnidades implements ListUnidadesUseCase {
  constructor(private readonly g: UnidadeGateway) {}
  execute(params: { page?: number; size?: number }): Promise<Page<Unidade>> { return this.g.list(params); }
}
export class CreateUnidade implements CreateUnidadeUseCase {
  constructor(private readonly g: UnidadeGateway) {}
  execute(cmd: UpsertUnidadeCommand): Promise<Unidade> { return this.g.create(cmd); }
}
export class UpdateUnidade implements UpdateUnidadeUseCase {
  constructor(private readonly g: UnidadeGateway) {}
  execute(id: string, cmd: UpsertUnidadeCommand): Promise<Unidade> { return this.g.update(id, cmd); }
}
export class ArchiveUnidade implements ArchiveUnidadeUseCase {
  constructor(private readonly g: UnidadeGateway) {}
  execute(id: string): Promise<void> { return this.g.archive(id); }
}

// ── Conteúdo externo ───────────────────────────────────────
export class ListExternalContents implements ListExternalContentsUseCase {
  constructor(private readonly g: ExternalContentGateway) {}
  execute(filter?: ExternalContentFilter): Promise<ExternalContent[]> { return this.g.list(filter); }
}
export class CreateExternalContent implements CreateExternalContentUseCase {
  constructor(private readonly g: ExternalContentGateway) {}
  execute(cmd: UpsertExternalContentCommand): Promise<ExternalContent> { return this.g.create(cmd); }
}
export class UpdateExternalContent implements UpdateExternalContentUseCase {
  constructor(private readonly g: ExternalContentGateway) {}
  execute(id: string, cmd: UpsertExternalContentCommand): Promise<ExternalContent> { return this.g.update(id, cmd); }
}
export class ArchiveExternalContent implements ArchiveExternalContentUseCase {
  constructor(private readonly g: ExternalContentGateway) {}
  execute(id: string): Promise<void> { return this.g.archive(id); }
}
